import React from 'react';
import  './Contact.css';

const Contact = () => {

    return (
        <div>
        <div className="hero  min-h-screen contact" >
            <div className="hero-overlay bg-opacity-20"></div>
            <div className="hero-content text-center text-neutral-content">
                <div className="max-w-md">
                    <h1 className="mb-5 text-5xl font-bold">  Princes Parts Limited.</h1>
                    <p className="mb-5">Location: Mirpur Dhaka-1216.</p>
                    <p>Emial:Princes.parts@help.com</p>
                     
                </div>
            </div>
        </div>
    </div>
    );
};

export default Contact;